// @ts-check

import {
  GET_BULK_TAGS,
  GET_BULK_TAGS_REFERENCES,
  DELETE_BULK_TAGS,
  GET_BULK_TAGS_URL
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getBulkTagsStatus = state => state.status[getActionStatusName(GET_BULK_TAGS)] || {};
export const deleteBulkTagsStatus = state => state.status[getActionStatusName(DELETE_BULK_TAGS)] || {};
export const getBulkTagsReferencesStatus = state => state.status[getActionStatusName(GET_BULK_TAGS_REFERENCES)] || {};
export const getBulkTagsUrlStatus = state => state.status[getActionStatusName(GET_BULK_TAGS_URL)] || {};

